module.exports = __webpack_public_path__ + "/static/assets/2a70b21aaaed0619bdfcdec91db1ebe8.svg";